import { render, staticRenderFns } from "./CreateSelfSignedCertificate.vue?vue&type=template&id=63e3c779&scoped=true&"
import script from "./CreateSelfSignedCertificate.vue?vue&type=script&lang=ts&"
export * from "./CreateSelfSignedCertificate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e3c779",
  null
  
)

export default component.exports